import { registerShader } from "aframe";


registerShader("ui",
{
	schema : 
	{
		color: {type: 'color', is: 'uniform' },
		opacity: {type: 'number', is: 'uniform' },
		src: { type: 'map', is: 'uniform' }
	},
	vertexShader: `
		varying vec2 vUv;
		void main() {
			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
		}
	`,
	fragmentShader: `
		varying vec2 vUv;
		uniform vec3 color;
		uniform float opacity;
		uniform sampler2D src;
		void main() {
			vec4 srcColor = texture2D(src, vUv);
			gl_FragColor = vec4( 
				mix( color, srcColor.rgb, srcColor.a ),
				srcColor.a + opacity - (srcColor.a * opacity)
			);
		}
		`

});